import { InMemoryCache } from 'apollo-cache-inmemory';
import { withClientState } from 'apollo-link-state';

const cache = new InMemoryCache();

const token = localStorage.getItem('quora-token');

const stateLink = withClientState({
  cache,
  defaults: {
    authStatus: {
      __typename: 'AuthStatus',
      isAuthenticated: token ? true : false,
      currentUser: null,
    },
  },
  resolvers: {
    Mutation: {
      updateAuthStatus: (_, { isAuthenticated, currentUser }, { cache }) => {
        const data = {
          authStatus: {
            __typename: 'AuthStatus',
            isAuthenticated,
            currentUser,
          },
        };
        
        cache.writeData({ data });
        
        return null;
      },
    },
  },
});

export default stateLink;
